import { LockOutlined } from '@mui/icons-material';
import { Alert, SxProps, Theme } from '@mui/material';

export interface MaskedBiddingAlertProps {
  message: string;
  sx?: SxProps<Theme>;
}

export const MaskedBiddingAlert = ({ message, sx }: MaskedBiddingAlertProps) => {
  return (
    <Alert icon={<LockOutlined />} sx={sx} color="warning">
      {message}
    </Alert>
  );
};
